(function CruiseSearchResults($, Adzuki)
{
	"use strict";
	var $searchTab   = $('#search-tab');
	var $compareTab  = $('#compare-tab');

	$(document).ready(function documentReady()
	{
		var cruiseSearchPages = ['/CruiseSearch/results', '/CruiseSearch/view'];

		Adzuki.onload(cruiseSearchPages, function onload()
		{
			var $container = $('.alternate-sailing-dates');
			// for comparison only
			var total_items            = 0,
				$comparison_container  = $('.comparison-widget'),
				$sidebar               = $('.cruise-sidebar');

			setItineraryCount();

			// show modal with cruisetours from search results
			$('.result-cruise-tours').click(function cruiseToursClicked(e) {
				var itinerary_id = $(this).data("itinerary-id"),
				    modal_title  = $(this).data("modal-title"),
				    $modal       = $(".modal");

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading Cruisetours...');

				Adzuki.Ajax.get('/Itineraries/cruiseToursByItineraryId/' + itinerary_id)
				.then(function success(html) {
					$modal.find('.modal-body').html(html);
					$modal.find('[data-toggle^="tooltip"]').tooltip();
				});

				$modal.find('.modal-title').text('Cruisetours - ' + modal_title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			// show day-by-day for cruise tours
			$(document).on('click', '.cruise-tour-days', function cruiseTourDays(e) {
				var $self    = $(this),
				    $icon    = $self.find('i'),
				    tour_id  = $self.data("itinerary-cruise-tour-id"),
				    $details = $('#details-' + tour_id);

				e.preventDefault();

				$details.toggleClass('hidden');
				$icon.toggleClass('fa-minus-square');
				$icon.toggleClass('fa-plus-square');
			});

			$('.cruise-search-alternate').click(function cruiseSearchAlternateClicked(e) {
				var $itinerary_id = $(this).data("id");

				e.preventDefault();

				$('#' + $itinerary_id).show();
				$('#' + $itinerary_id).html('<div class="alternate-loading"><i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-lg fa-fw"></i><span class="sr-only"></span>Loading...</div>');

				Adzuki.Ajax.get('/CruiseSearch/alternateSailings/' + $itinerary_id).then(function success(response) {
					$('#' + $itinerary_id).html(response);
				});
			});

			$container.on('click', '.close-alternate', function resultCruiseLineChanged() {
				var $itinerary_id = $(this).data("id");

				$('#' + $itinerary_id).hide();
				$('#' + $itinerary_id).html('');
			});

			$('.shore-excursions').click(function showShoreExcursions(e) {
				var $self          = $(this),
					$modal         = $(".modal"),
					itinerary_id   = $self.data("id"),
					company        = $self.data('company'),
					modal_title    = 'Shoretrips Excursions';

				if (company === 'shore_excursions_group') {
					modal_title = 'Shore Excursions Group';
				}

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').html('<i class="fa fa-spinner fa-spin fa-2x"></i>&nbsp;Loading shore excursions...');

				Adzuki.Ajax.get('/Excursions/getByItineraryId/' + itinerary_id)
					.then(function _showExcursions(html) {
						$modal.find('.modal-body').html(html);
						$modal.find('[data-toggle^="tooltip"]').tooltip();

						Adzuki.Buckets.initAddButton($modal.find('.bucket-addto'));
				});

				$modal.find('.modal-title').text(modal_title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			$('.result-amex-group-details').click(function showAmexGroupDetails(e) {
				var group_id = $(this).data("amex-group-id"),
					$modal   = $(".modal");

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading AMEX Cruise Group Details...');

				Adzuki.Ajax.get('/AmexCruiseGroups/detail/' + group_id)
				.then(function success(html) {
					$modal.find('.modal-body').html(html);
					$modal.find('[data-toggle^="tooltip"]').tooltip();
				});

				$modal.find('.modal-title').text('AMEX Cruise Group Details');
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			$('.result-amex-mr-details').click(function showAmexMembershipRewardsDetails(e) {
				var promo_id = $(this).data("amex-mr-id"),
					$modal   = $(".modal");

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading AMEX Membership Rewards Details...');

				Adzuki.Ajax.get('/CruiseSearch/mrPromotionDetails/' + promo_id)
				.then(function success(html) {
					$modal.find('.modal-body').html(html);
					$modal.find('[data-toggle^="tooltip"]').tooltip();
				});

				$modal.find('.modal-title').text('AMEX Membership Rewards Details');
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			$('.result-signature').click(function showSignatureDetails(e) {
				var offer_id = $(this).data("offer-id"),
					$modal   = $(".modal");

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading Amenities Details...');

				Adzuki.Ajax.get('/SignatureTravelNetwork/details/' + offer_id)
				.then(function success(html) {
					$modal.find('.modal-body').html(html);
					$modal.find('[data-toggle^="tooltip"]').tooltip();
				});

				$modal.find('.modal-title').text('Signature Travel Network Exclusive');
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			$(document).on('click', '.result-group-details', function showGroupDetails(e) {
				var group_id = $(this).data("group-id"),
					$modal   = $(".modal"),
					url      = '/GroupsHo/detail/' + group_id;

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading Group Details...');

				if ($(this).hasClass('check-advantage')) {
					url = '/GroupsHo/detail/' + group_id + '/1';
				}

				Adzuki.Ajax.get(url)
				.then(function success(html) {
					$modal.find('.modal-body').html(html);
					$modal.find('[data-toggle^="tooltip"]').tooltip();
				});

				$modal.find('.modal-title').text('Group Details');
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			$(document).on('click', '.modal .info-link a', function showInfo(e) {
				e.preventDefault();
				$(this).siblings('.content').slideToggle();
			});

			$('.cpview-detail').on('click', '.close-cpview', function resultCloseCpView() {
				var $itinerary_id = $(this).data("id");

				if ($('#cpview-' + $itinerary_id).hasClass("full-width")) {
					$('#cpview-' + $itinerary_id).removeClass('show');
				} else {
					$('#cpview-' + $itinerary_id).hide();
				}

				$('#cpview-' + $itinerary_id).html('');
			});

			$('.result-cruise-lines').change(function resultsCruiseLineChanged() {
				var cruise_line_id = $(this).val();

				if ($.trim(cruise_line_id)) {
					Adzuki.Ajax.get('/CruiseSearch/getShips/' + cruise_line_id)
					.then(function success(data) {
						var sortedData = Adzuki.Sort.alphabeticValue(data);

						$('.result-ships').empty();
						$('.result-ships').append($('<option>').text('Any Ship').attr('value', ''));

						$.each(sortedData, function qaParseShips(key, ship) {
							$('.result-ships').append($('<option>').text(ship['value']).attr('value', ship['key']));
						});
					});
				}
			});

			$('.result-clear-form').click(function clearCruiseForm() {
				var selected_index = 0;

				$('.cruise-search-vertical  select').prop('selectedIndex', selected_index);

				$('.result-ships').empty();
				$('.result-ships').append($('<option>').text('Any Ship').attr('value', ''));
			});

			$('.cruise-search-form-element').change(function getItineraryCount() {
				setItineraryCount();
			});

			$('.result-search-date').change(function adjustDates() {
				adjustDateFields();
			});

			$('.cruise-search-cpview').click(function cruiseSearchCpViewClicked(e) {
				var $itinerary_id = $(this).data("id");

				e.preventDefault();

				$('#cpview-' + $itinerary_id).html('<div class="cpview-loading"><i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-lg fa-fw"></i><span class="sr-only"></span>Analyzing Sailing...</div>');

				Adzuki.Ajax.get('/CruiseSearch/cpview/' + $itinerary_id).then(function success(response) {
					$('#cpview-' + $itinerary_id).html(response);

					$('[data-toggle^="tooltip"]', '#cpview-' + $itinerary_id).tooltip();
				});
			});

			$('.cruise-search-summary-cpview').click(function cruiseSearchCpViewSummaryClicked(e) {
				var $itinerary_id = $(this).data("id");

				e.preventDefault();

				$('#cpview-' + $itinerary_id).addClass('show');
				$('#cpview-' + $itinerary_id).html('<div class="cpview-loading"><i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-lg fa-fw"></i><span class="sr-only"></span>Analyzing Sailing...</div>');

				Adzuki.Ajax.get('/CruiseSearch/cpview/' + $itinerary_id).then(function success(response) {
					$('#cpview-' + $itinerary_id).html(response);

					$('[data-toggle^="tooltip"]', '#cpview-' + $itinerary_id).tooltip();
				});
			});

			$('.collapse-cruise-details').click(function expandCollapseCruiseBoxClicked(e) {
				var itinerary_id = $(this).data("itinerary-id"),
					a_tag        = $(this),
					state        = $(this).data("state");

				e.preventDefault();

				$('.cruise').each(function findCruiseBox() {
					if ($(this).data("itinerary-id") === itinerary_id) {

						if (state === 'expanded') {
							a_tag.html('<i class="'+Adzuki.FaIcon.getIconStyle('expand')+' fa-lg"></i>');
							a_tag.data("state", "collapsed");
							$(this).slideUp();
						} else {
							a_tag.html('<i class="'+Adzuki.FaIcon.getIconStyle('collapse')+' fa-lg"></i>');
							a_tag.data("state", "expanded");
							$(this).slideDown();
						}
					}
				});
			});

			$(document).on('click', '.cpview-checkbox', function cpViewCheckboxClicked() {
				if ($(this).prop('checked') === true) {
					$('.cpview-checkboxes').each(function cpViewBoxCheckUncheck() {
						$(this).prop('checked', true);
					});
				} else {
					$('.cpview-checkboxes').each(function cpViewBoxCheckUncheck() {
						$(this).prop('checked', false);
					});
				}
			});

			$(document).on('click', '.cpview-cruise-sheet', function cpViewSendCruiseSheet() {
				var num_checked  = 0,
					client_ids   = '',
					itinerary_id = $(this).data("itinerary-id");

				$('.cpview-checkboxes').each(function cpViewBoxCheckUncheck() {
					if ($(this).prop('checked') === true) {
						num_checked++;
						client_ids += $(this).data("id") + '|';
					}
				});

				if (num_checked > 0) {
					document.location = Adzuki.base_uri + '/CruiseSheets/index/itinerary_id:' + itinerary_id + '/clients:' + client_ids;
				} else {
					Adzuki.StatusMessage(null, 'You must select at least 1 client in order to send a cruise sheet.', 'No clients selected');
				}
			});

			$(document).on('click', '.cpview-ecard', function cpViewEcard() {
				var num_checked  = 0,
					client_ids   = '';

				$('.cpview-checkboxes').each(function cpViewBoxCheckUncheck() {
					if ($(this).prop('checked') === true) {
						num_checked++;
						client_ids += $(this).data("id") + '|';
					}
				});

				if (num_checked > 0) {
					document.location = Adzuki.base_uri + '/Ecards/add/clients:' + client_ids;
				} else {
					Adzuki.StatusMessage(null, 'You must select at least 1 client in order to send an ecard.', 'No clients selected');
				}
			});


			// COMPARISON CODE BELOW
			setAffixWidth();

			$('.cruise-comparison').click(function cruiseComparisonSailings(e) {
				var comparison_ids  = Cookies.get('comparison_ids') || '',
				    comparison_str  = '',
				    itinerary_id    = $(this).data("id"),
				    ids             = '',
				    max_itineraries = 5, //	arbitrary
				    i               = 0,
				    min_total_items = 0;

				if ($(this).prop('checked') === true) {
					if (comparison_ids === '') {
						comparison_str = itinerary_id;
						total_items    = 1;
					} else {
						ids         = comparison_ids.split(',');
						total_items = ids.length;

						if (ids.length >= max_itineraries) {
							if (ids.length >= max_itineraries) {
								Adzuki.StatusMessage(null, 'You can only compare up to ' + max_itineraries + ' sailings at a time', 'Comparison Max Reached');

								comparison_str = comparison_ids;
								$(this).prop('checked', false);
							}
						} else {
							total_items++;
							comparison_str = comparison_ids + ',' + itinerary_id;
						}
					}
				} else if (comparison_ids) {
					comparison_str = '';
					ids            = comparison_ids.split(',');
					total_items    = 0;

					for (i=0;i<=ids.length;i++) {
						if (parseInt(ids[i]) === parseInt(itinerary_id)) {
							ids.splice(i, 1);
						} else {
							total_items++;
						}
					}

					comparison_str = ids.join(",");
				}

				if (total_items > min_total_items) {
					Cookies.set('comparison_ids', comparison_str, {
						expires: 7,
						path   : '/'
					});

					showComparisonWidget();
				} else {
					Cookies.remove('comparison_ids');

					hideComparisonWidget();
				}
			});

			$comparison_container.on('click', '.comparison-remove', function comparisonRemoveOne(e) {
				var comparison_ids  = Cookies.get('comparison_ids') || '',
				    comparison_str  = '',
				    ids             = '',
				    itinerary_id    = $(this).data("id"),
				    i               = 0,
				    min_total_items = 0,
				    decrementor     = 1;

				e.preventDefault();

				ids = comparison_ids.split(',');

				for (i=0;i<=ids.length;i++) {
					if (parseInt(ids[i]) !== parseInt(itinerary_id)) {
						if (comparison_str === '' && ids[i] !== itinerary_id && !isNaN(ids[i])) {
							comparison_str = ids[i];
						} else if (ids[i]) {
							comparison_str += ',' + ids[i];
						}
					}
				}

				$('.cruise-comparison').each(function uncheckOne() {
					if ($(this).data("id") === itinerary_id) {
						$(this).prop('checked', false);
					}
				});

				total_items = parseInt(ids.length) - decrementor;

				if (total_items > min_total_items) {
					Cookies.set('comparison_ids', comparison_str, {
						expires: 7,
						path   : '/'
					});

					showComparisonWidget();
				} else {
					Cookies.remove('comparison_ids');
					hideComparisonWidget();
					toggleBadge(0);
				}
			});

			$comparison_container.on('click', '.comparison-remove-all', function comparisonRemoveAll() {
				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: 'Are you sure you want to remove all?',
					confirm: function confirm() {
						Cookies.remove('comparison_ids');
						showComparisonWidget();
						toggleBadge(0);
						$('.cruise-comparison').each(function uncheckAll() {
							$(this).prop('checked', false);
						});
						hideComparisonWidget();
					}
				});
			});

			$comparison_container.on('click', '.comparison-view', function comparisonRemoveAll() {
				var comparison_ids  = Cookies.get('comparison_ids') || '';

				document.location = Adzuki.base_uri + '/CruiseSearch/compare/' + comparison_ids;
			});


			$comparison_container.on('click', '.comparison-cruise-sheets', function comparisonCruiseSheets(e) {
				var comparison_ids = Cookies.get('comparison_ids') || '',
				    afc            = $('#cruise-search-criteria').data('afc');

				    e.preventDefault();

				document.location = Adzuki.base_uri + '/CruiseSheets/createFromCompare/' + afc + '/' + comparison_ids;
			});

			if (Cookies.get('comparison_ids')) {
				if (Cookies.get('comparison_ids').length > 0) {
					showComparisonWidget();
				}
			}

			// trigger the cruise line selection so the ships get loaded
			$('.quick-search-container .qa-cruise-lines').trigger("change");

			setTimeout(function selectShipIfAvailable() {
				// if we have a ship, please select it. thank you berry much
				if ($('.quick-search-container #cruisesearch-ship_hidden').val() !== '') {
					$('.quick-search-container .qa-ships').val($('.quick-search-container #cruisesearch-ship_hidden').val());
					$('.quick-search-container .qa-ships').trigger("change");
				}
			}, 500);

			if ($sidebar.length > 0) {
				$(window)
					.on(
						'resize',
						Adzuki.Debounce(function positionBottomPanel() {
							setAffixWidth();
						},
						500
						)
					)
				;
			}
			// END COMPARISON

			$('.vidanta_promo').click(function vidantaClicked(e) {
				var $modal = $(".modal");

				e.preventDefault();

				$modal.find('.modal-body').html('This sailing qualifies your client for the Vidanta Resort Promotion if paid with an American Express card.  Once you have made one or more American Express card payments (between 7/1 - 12/31) towards a booking for sailing, within 10 days, your client will be emailed a voucher for a 4 night stay at the Vidanta resort and instructions on how to redeem.  You will be copied on this email as well.');
				$modal.find('[data-toggle^="tooltip"]').tooltip();

				$modal.find('.modal-title').text('Vidanta Promotion');
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

		}, false);
	});

	function setItineraryCount() {
		var form_data    = $('.results-find-submit').serialize();
		var record_count = 0;

		Adzuki.Ajax.post('/CruiseSearch/getCount', form_data)
		.then(function success(data) {
			record_count = parseInt(data[0]['dynamic'].count);
			record_count = record_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

			$('.result-count').html('<span class="result-count-label">results</span> ' + record_count);
		});
	}

	function adjustDateFields() {
		var $start_month    = $('#result-start-month').val();
		var $start_year     = $('#result-start-year').val();
		var $end_month      = $('#result-end-month').val();
		var $end_year       = $('#result-end-year').val();

		var start_date      = $start_year + $start_month;
		var end_date        = $end_year + $end_month;

		if (start_date > end_date) {
			$('#result-end-year').val($start_year);
			$('#result-end-month').val($start_month);
		}
	}

	// CUSTOM COMPARISON FUNCTIONS
	function showComparisonWidget() {
		var comparison_ids  = Cookies.get('comparison_ids');
		var ids             = [];
		var comapreCountBadge = $('#compare-cruise-tab').find('.badge');
		// $('.comparison-widget-box').show();

		Adzuki.Ajax
			.get('/CruiseSearch/comparisonWidget/' + comparison_ids)
			.then(
				function success(response) {
					var count = $(response).find('tbody').children().length;
					$('.comparison-widget').html(response);

					// init buckets
					Adzuki.Buckets.initAddButton($('.comparison-widget .bucket-addto'));

					if (count > 0) {
						$('#compare-cruise-tab').tab('show');
						toggleBadge(count);
					}
				}
			)
		;

		if (comparison_ids) {
			ids = comparison_ids.split(',');
		}

		if (ids.length) {
			comapreCountBadge.text(ids.length);
			comapreCountBadge.show();
		} else {
			comapreCountBadge.hide();
		}
		$compareTab.show();
	}

	function hideComparisonWidget() {
		// $('.comparison-widget-box').hide();
		$('.comparison-widget').html('');

		$compareTab.hide();
		$searchTab.find('a').tab('show');
	}

	function setAffixWidth() {
		var parentWidth  = $('[data-spy=affix]').parent().width();
		var paddingLeft  = $('[data-spy=affix]').css('padding-left');
		var paddingRight = $('[data-spy=affix]').css('padding-right');

		$('[data-spy=affix]').width(parentWidth - (parseInt(paddingLeft) + parseInt(paddingRight)));
	}

	function toggleBadge(count) {
		var $badge = $('#compare-cruise-tab').find('.badge');

		if (count > 0) {
			$badge.css('display', 'inline-block');
			$badge.text(count);
		} else {
			$badge.hide();
		}
	}
}(jQuery, window.Adzuki || {}));
